import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BrandService } from '../service/brand/brand.service';

@Component({
  selector: 'app-legal-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="legal-footer" aria-label="Legal links">
      @if (brand.showCopyright) {
        <span>&copy; {{ year }} {{ brand.copyrightHolder }}</span>
      }
      <nav>
        <a routerLink="/privacy">Privacy</a>
        <a routerLink="/terms">Terms</a>
      </nav>
    </footer>
  `,
  styles: [`
    .legal-footer { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 12px 24px; padding: 20px 4px; color: #617086; font-size: .8rem; }
    nav { display: flex; flex-wrap: wrap; gap: 8px 16px; }
    a { color: inherit; }
    a:hover { color: #1f6bff; }
  `],
})
export class LegalFooterComponent {
  readonly year = new Date().getFullYear();
  protected readonly brand = inject(BrandService);
}
